import { Component } from "react";
import { connect, ConnectedComponent } from "react-redux";
import { ClientPortalPaymentModes } from "../../../../Common/organisationInfo";
import { IStore, IConfirmationStepInfo, Step, IServiceStepInfo } from "../../../DataTypes/storeTypes";
import { selectIsStripeConnected, selectPortalPaymentMode } from "../../../Helpers/selectors";
import { Button, Link } from "@powerdiary/components-library/lib";
import { Collapse } from "@mui/material";

interface IProps {
    isBusy: boolean;
    termsAndConditions: string;
    isPayable: boolean;
}

interface ITermsAndSubmitState {
    showTermsAndConditions: boolean;
}

class TermsAndSubmit extends Component<IProps, ITermsAndSubmitState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            showTermsAndConditions: false,
        };
    }

    updateTermsAndConditions = () => {
        this.setState({ showTermsAndConditions: !this.state.showTermsAndConditions });
    };

    render() {
        const submitText = this.props.isPayable ? "Pay and book now" : "Book now";

        return (
            <div className="terms-and-submit-box mt-3 pb-0">
                <div className="row">
                    <div className="col-12 col-lg-6 d-flex align-items-center mb-3 mb-lg-0">
                        {this.props.termsAndConditions && (
                            <div className="terms-conditions-checkbox">
                                By clicking "Book Now" you accept the{" "}
                                <Link variant="mediumRegular" href="#" onClick={() => this.updateTermsAndConditions()}>
                                    terms and conditions of use
                                </Link>
                            </div>
                        )}
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="text-md-right d-md-block d-flex justify-content-between">
                            <Button
                                variant="contained"
                                type="submit"
                                size="large"
                                disabled={this.props.isBusy}
                                className="btn-block"
                            >
                                {submitText}{" "}
                                {this.props.isBusy ? <i className="fa fa-spinner fa-spin fsize18 ml-3" /> : null}
                            </Button>
                        </div>
                    </div>

                    <div className="w-100" />
                    <div className="col-12">
                        <Collapse in={this.state.showTermsAndConditions}>
                            <div id="terms-and-Conditions">
                                <hr className="mt-4" />
                                <div
                                    className="mt-3"
                                    dangerouslySetInnerHTML={{ __html: this.props.termsAndConditions }}
                                />
                            </div>
                        </Collapse>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: IProps): IProps => {
    const info = state.stepsInfo[state.common.currentStep] as IConfirmationStepInfo;
    const settings = state.initialSettings.accountInitialSettings.organisationInfo;
    const serviceInfo = state.stepsInfo[Step.Service] as IServiceStepInfo;
    const isPayable =
        (selectPortalPaymentMode(state) == ClientPortalPaymentModes.Required ||
            info.showStripe ||
            serviceInfo.isPortalDeposit) &&
        serviceInfo.amount > 0 &&
        selectIsStripeConnected(state);

    return {
        ...ownProps,
        isBusy: state.common.isBusy,
        termsAndConditions: settings.termsAndConditions,
        isPayable: isPayable,
    };
};

export const TermsAndSubmitConnected: ConnectedComponent<typeof TermsAndSubmit, any> =
    connect(mapStateToProps)(TermsAndSubmit);
